import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from '../../../assets/images/logos/576_Cash Canvas-03.png';

const NavBar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { label: "About", to: "/about-us" },
    { label: "Pricing", to: "/pricing" },
    { label: "Blog", to: "/blog" },
  ];

  return (
    <header className="fixed top-0 w-full z-50 bg-btn-primary shadow-sm">
      <div className="w-full flex items-center justify-between h-20 px-2">
        {/* Logo - far left */}
        <div className="flex-shrink-0 mx-2">
          <Link to="/">
            <img src={logo} alt="Cash Canvas Logo" className="h-44 w-auto" />
          </Link>
        </div>

        {/* Navigation - center */}
        <nav className="hidden md:flex items-center space-x-12">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-btn-primary-text text-lg font-semibold hover:text-btn-secondary transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Auth Buttons - far right */}
        <div className="hidden md:flex items-center space-x-4 mx-2">
          <button
            onClick={() => navigate("/login")}
            className="bg-btn-primary hover:bg-btn-primary-hover text-btn-primary-text px-4 py-2 rounded-lg transition-colors"
          >
            Log in
          </button>
          <button
            onClick={() => navigate("/signup")}
            className="bg-btn-secondary hover:bg-btn-secondary-hover text-btn-secondary-text px-4 py-2 rounded-lg transition-colors shadow-md"
          >
            Sign up
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center mx-2">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-btn-primary-text hover:text-btn-secondary focus:outline-none transition-colors"
            aria-label="Toggle menu"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-md">
          <div className="px-4 pt-4 pb-6 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="block px-3 py-2 text-btn-primary text-base font-semibold hover:text-btn-secondary transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <hr className="my-2 border-gray-200" />
            <div className="flex space-x-2">
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/login");
                }}
                className="w-1/2 px-3 py-2 bg-btn-secondary hover:bg-btn-secondary-hover text-btn-secondary-text rounded-lg transition-colors text-center"
              >
                Log in
              </button>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/signup");
                }}
                className="w-1/2 px-3 py-2 bg-btn-primary hover:bg-btn-primary-hover text-btn-primary-text rounded-lg transition-colors text-center"
              >
                Sign up
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavBar;